import { ChatCircleText, MagnifyingGlass } from '@phosphor-icons/react'

import { Pill } from '@/components/shared/horizon'
import AISparkle from '@/components/shared/icons/AISparkle'

export const adminHomeSidebarNavigation = [
  {
    key: 'aiInsights',
    link: '/admin/home',
    anotherHref: ['/admin/home'],
    labelTransKey: 'common.insights',
    icon: <AISparkle className='h-4 w-4' />,
    availableRoles: ['csm', 'admin', 'member'],
    isExact: true,
    customBadge: (
      <div>
        <Pill
          variant={'blue'}
          className='!rounded-lg !px-2 !py-0 font-mono text-xxs '
        >
          AI
        </Pill>
      </div>
    ),
  },
  {
    key: 'search',
    link: '/admin/home/search',
    anotherHref: ['/admin/home/search'],
    labelTransKey: 'common.labels.search',
    icon: <MagnifyingGlass size={18} />,
    availableRoles: ['csm', 'admin', 'member'],
    isExact: true,
  },
  {
    key: 'chat',
    link: '/admin/home/chat',
    anotherHref: ['/admin/home/chat'],
    labelTransKey: 'common.labels.chat',
    icon: <ChatCircleText size={18} />,
    availableRoles: ['csm', 'admin', 'member'],
    isExact: true,
    customBadge: (
      <div>
        <Pill
          variant={'blue'}
          className='!rounded-lg !px-2 !py-0 font-mono text-xxs '
        >
          AI
        </Pill>
      </div>
    ),
  },
]

export const adminHomeSidebarNavigationGroups = [
  {
    key: 'aiInsights',
    labelTransKey: 'common.insights',
  },
]
